import { BaseState } from '@/store/base-state';
import { Patchnotes } from '../types';

export default class PatchNotesState extends BaseState {
  patch_notes: Patchnotes.PatchNote[] = [];

  patchnotes_loading = false;
  filters = {};
}
